import { useEffect, useState } from "react";
import Modal from "../../../components/Modal";
import { Rating } from "../../praxis-call/components/Rating";
import { Button } from "../../../components/Button";
import { useApp } from "../../../services/app-context";

function RatingCard({
  label,
  value,
  onChange,
  isFilled,
}: {
  isFilled: boolean;
  label: string;
  value: number;
  onChange: (value: number) => void;
}) {
  return (
    <div
      className={`${
        isFilled ? "bg-[#8DD48F38]" : "bg-[#F8F8F8]"
      } rounded-[10px] px-5 pt-[22px] pb-7 [&_svg]:w-8 [&_svg]:h-7 [&_.star-container]:!ml-0`}
    >
      <div className="text-[#1E1E1E] text-lg mb-1">{label}</div>

      <Rating value={value} onChange={onChange} showCount={false} />
    </div>
  );
}

const fields = [
  { label: "Language Clarity and Precision", field: "language_clarity" },
  { label: "Vocabulary and Terminology", field: "vocabulary" },
  { label: "Response Time", field: "response_time" },
  { label: "Questioning Techniques", field: "questioning_techniques" },
  { label: "Brand Strategy Alignment", field: "brand_strategy_alignment" },
  { label: "Tone and Diction", field: "tone_and_diction" },
  { label: "Messaging Compliance", field: "compliance" },
  { label: "Tone", field: "tone" },
];

export function SelfEvaluationForm({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { tenantProfile } = useApp();
  const self_evaluation = tenantProfile?.self_evaluation || {};
  const rating_scale = self_evaluation.rating_scale || 5;
  const rating_categories = self_evaluation.rating_categories || [];

  const [form, setForm] = useState<
    {
      [key: string]: number;
    }[]
  >([]);

  const handleSubmit = () => {
  };

  const resetForm = () => {
    setForm([]);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  useEffect(() => {
    if (rating_scale) {
      setForm(
        rating_categories.map((category) => ({
          [category.field]: 0,
        }))
      );
    }
  }, [rating_categories]);

  return (
    <Modal
      contentClassName="!px-0 lg:w-[789px]"
      title="Self- Evaluation Form"
      isOpen={isOpen}
      handleModal={onClose}
    >
      <div className="max-h-[calc(100vh-125px)] overflow-auto p-6">
        <div className="text-text-primary text-lg ">
          Reflect on your recent performance across key areas to identify
          strengths and growth opportunities.
        </div>
        <div className="text-text-primary text-lg my-2">
          Select a rating for each section
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {fields.map((field) => (
            <RatingCard
              key={field.field}
              label={field.label}
              value={form[field.field] || 0}
              onChange={(value) => setForm({ ...form, [field.field]: value })}
              isFilled={form[field.field]}
            />
          ))}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button
            variant="outline"
            className="!rounded-full !py-2"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="primary"
            className="!rounded-full !py-2"
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
}
